<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-calculator heroicon heroicon-sm"
  >
    <rect
      class="heroicon-calculator-body heroicon-component-fill"
      width="46"
      height="38"
      x="7"
      y="21"
      fill="#FFFFFF"
    ></rect>
    <rect
      class="heroicon-calculator-top heroicon-component-accent heroicon-component-fill"
      width="46"
      height="20"
      x="7"
      y="1"
      fill="#7ACFC0"
      transform="matrix(1 0 0 -1 0 22)"
    ></rect>
    <rect
      class="heroicon-calculator-screen heroicon-component-fill"
      width="34"
      height="6"
      x="13"
      y="9"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-calculator-buttons-numbers heroicon-component-fill"
      fill="#FFFFFF"
      d="M11 25h8v6h-8v-6zm10 0h8v6h-8v-6zm10 0h8v6h-8v-6zm0 8h8v6h-8v-6zm-10 0h8v6h-8v-6zm-10 0h8v6h-8v-6zm0 8h8v6h-8v-6zm0 8h18v6H11v-6zm10-8h8v6h-8v-6zm10 0h8v6h-8v-6zm0 8h8v6h-8v-6z"
    ></path>
    <path
      class="heroicon-calculator-buttons-equations heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M41 25h8v6h-8v-6zm0 8h8v6h-8v-6zm0 8h8v6h-8v-6zm0 8h8v6h-8v-6z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M12 8h36l-1 1H13l-1-1zm-1 23h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm-30 8h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm-30 8h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm10 0h8v1h-8v-1zm-30 8h18v1H11v-1zm20 0h8v1h-8v-1zm10 0h8v1h-8v-1zM8 22h44v1H8v-1z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M8 0h44a2 2 0 0 1 2 2v56a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V2c0-1.1.9-2 2-2zm44 2H8v18h44V2zm0 20H8v36h44V22zM11 7h38v10H11V7zm1 1v8h36V8H12zm2 1h33v6H13V9h1zm32 1H14v4h32v-4zM27 4h7v1h-8V4h1zM12 49h17v6H11v-6h1zm16 1H12v4h16v-4zm4-1h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm-10-9h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm-30-1h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm10-9h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm-30-1h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm10-9h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6zm-30-1h7v6h-8v-6h1zm6 1h-6v4h6v-4zm3-1h8v6h-8v-6zm1 1v4h6v-4h-6z"
    ></path>
  </svg>
</template>
